<div class="container text-left">
  <div class="container">
    <form [formGroup]="form">
      <h3 class="subtitulo">Processo</h3>
      <div class="form-row">
        <div class="col-7">
          <app-nro-processo-input formControlName="nroProcesso" [tokenIam]="tokenIam" tipoOrdem="CEND"></app-nro-processo-input>
        </div>
      </div>
      <app-sla-selector [form]="form"></app-sla-selector>

      <app-lista-titulares [titulares]="titulares" [tipoOrdem]='"CEND"' (titularesChange)="onTitularesChange($event)"></app-lista-titulares>

      <br />

      <div class="row mt-5">
        <div class="col-sm-7"></div>
        <div class="col-sm-5">
          <app-acao-buttons
            [tipoOrdem]="'CEND'"
            (onConfirmar)="consultaEndereco()"
          ></app-acao-buttons>
        </div>
      </div>
    </form>
  </div>
</div>
